import { copyApiPrefilterPerRole } from "@shared/backend/entity-security/copy-api-prefilter-per-role";
import { doesExist } from "@shared/backend/entity-security/does-exist";
import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { awaiter } from "@shared/helpers/awaiter";
import { Roles } from "@shared/Roles";
import { Allow, remult } from "remult";
import { Group } from "../group/entity";
import { Opportunity } from "../opportunity";
import { type GroupOpportunity } from "./entity";

export const GroupOpportunityEntityConfig: HyperEntityConfig<GroupOpportunity> =
{
  allowApiRead: Allow.authenticated,
  allowApiCrud: [Roles.Admin, Roles.SuperAdmin, Roles.Manager],
  apiPrefilterPerRole: async (filter) => {
    filter(Roles.All, {
      group: {
        $is: await copyApiPrefilterPerRole(Group),
      },
    });

    filter(Roles.All, {
      opportunity: {
        $is: await copyApiPrefilterPerRole(Opportunity),
      },
    });
  },

  allowInsertPerRole(allow) {
    // Admin/manager adding a group to a mission = immediate registration.
    allow(Roles.User, (entity) =>
      doesExist(
        Group,
        Group.hyperFilter({
          id: entity.groupId,
          admin: {
            $id: remult.user!.id,
          },
        }),
      ),
    );

    allow(Roles.OrganizationManagers, (entity) =>
      doesExist(Group, {
        id: entity.groupId,
        organization: {
          $id: remult.user!.organizationId!,
        },
      }),
    );
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.User, {
      group: {
        $is: {
          admin: {
            $id: remult.user!.id,
          },
        },
      },
    });

    allow(Roles.OrganizationManagers, {
      group: {
        $is: {
          organization: {
            $id: remult.user!.organizationId!,
          },
        },
      },
    });
  },
  async deleting(entity) {
    const group = await remult.repo(Group).findId(entity.groupId);
    if (group?.volunteerOrganizationId) {
      throw new Error(
        "אי אפשר לנתק קבוצה של ארגון מתנדבים מהמשימה. המאצ'ים נשארים.",
      );
    }
  },

  async onInsert(entity, e) {
    const [group, opportunity] = await awaiter(
      e.relations.group.findOne({
        include: {
          admin: true,
        },
      }),
      e.relations.opportunity.findOne({
        include: {
          organization: true,
        },
      }),
    );

    const admin = group?.admin;

    if (!admin || !opportunity) return;

    // SMS removed - group opportunity approval notification no longer sent
  },
  id: {
    groupId: true,
    opportunityId: true,
  },
};
